export let dataProps = {
    id: 0,
    category_id: null,
    sl_no: 0,
    applicable_stores: []
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreTopMenu/properties.js